import React from 'react';
import { Box, Heading, Button, VStack, Text, Link } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';

const LoginMulti = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEmailLogin = () => {
    navigate('/login');
  };

  const handleGoogleLogin = () => {
    // Redirige al endpoint de autenticación de Google del backend
    window.location.href = `${getApiBaseUrl()}/api/auth/google/`;
  };

  const handleTiktokLogin = (role) => {
    const API_BASE_URL = getApiBaseUrl();
    window.location.href = `${API_BASE_URL}/api/auth/tiktok?role=${encodeURIComponent(role)}`;
  };

  return (
    <Box p={4} maxW="400px" mx="auto" mt={10}>
      <Heading as="h2" size="lg" mb={6} textAlign="center">
        {t('login_multi_titulo')}
      </Heading>
      <VStack spacing={6}>
        <Button
          colorScheme="blue"
          width="100%"
          onClick={handleEmailLogin}
        >
          {t('login_multi_email')}
        </Button>
        <Text>{t('login_multi_o')}</Text>
        <Button
          className="oauth-provider-button oauth-provider-google"
          width="100%"
          onClick={handleGoogleLogin}
          leftIcon={
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Logo_2013_Google.png"
              alt="Google"
              style={{ width: 20, height: 20 }}
            />
          }
        >
          {t('login_multi_google')}
        </Button>
        <Button
          className="oauth-provider-button oauth-provider-tiktok"
          width="100%"
          onClick={() => handleTiktokLogin('cliente')}
        >
          {t('login_tiktok_cliente')}
        </Button>
        <Button
          className="oauth-provider-button oauth-provider-tiktok"
          width="100%"
          onClick={() => handleTiktokLogin('conductor')}
        >
          {t('login_tiktok_conductor')}
        </Button>
      </VStack>
      <Box mt={8} textAlign="center">
        <Text fontSize="sm" color="gray.500">
          {t('login_multi_no_cuenta')}{' '}
          <Link color="blue.600" href="/registro-cliente">
            {t('login_multi_registro_cliente')}
          </Link>
          {' '}{t('login_multi_o')}{' '}
          <Link color="blue.600" href="/registro-conductor">
            {t('login_multi_registro_conductor')}
          </Link>
        </Text>
      </Box>
    </Box>
  );
};

export default LoginMulti;